module.exports = __webpack_public_path__ + "static/media/02_Referenz_5w-50-min-min.82c974e0.jpg";